import React, { useState, useContext, useEffect } from "react";
import { MDBInput, MDBBtn } from "mdb-react-ui-kit";
import moment from "moment";
import { AVATAR, LOGO } from "../src/Componentes/Image";
import { Row, Col, Container, Label } from "reactstrap";
import {get_caja_data,get_cajas,get_compania,url} from "./Componentes/Services";
import StoreContext from "./Componentes/Store/Context";
import { useNavigate } from "react-router-dom";
import { ListaCajas } from "./Componentes/Modal";
function initialState() {
  return { usr_user: "", usr_pwd: "" };
}

async function login({ usr_user, usr_pwd }) {
  var usr_key_l = moment(new Date()).format("YYYYMMDDHHmmss");
  if (usr_user.length > 0 && usr_pwd.length > 0) {
    const dataBody = {
      usr_user,
      usr_pwd,
      usr_key_login: usr_key_l,
    };

    const requestOptions = {
      method: "POST",
      body: JSON.stringify(dataBody),
    };
    const response = await fetch(url + "LoginController/login", requestOptions);
    const result = await response.json();
    if (result[0] !== undefined) {
      if (result[0].count !== "0") {
        return {
          token: true,
          usr_perfil: result[0].usr_perfil,
          usr_id: result[0].usr_id,
          usr_nombre: result[0].usr_nombre,
          usr_sucursal: result[0].usr_sucursal,
          usr_print: result[0].usr_print,
          usr_ajustes: result[0].usr_ajustes,
          usr_factura: result[0].usr_factura,
          usr_inventario: result[0].usr_inventario,
          usr_cotizacion: result[0].usr_cotizacion,
          usr_articulo: result[0].usr_articulo,
          usr_reporte: result[0].usr_reporte,
          usr_a_costo:result[0].usr_a_costo,
          usr_company: result[0].usr_company,
          usr_apartado: result[0].usr_apartado,
          usr_gastos: result[0].usr_gastos,
          usr_clientes: result[0].usr_clientes,
          usr_precio: result[0].usr_precio,
          com_suc_emisor: result[0].com_suc_emisor,
          usr_key_login: usr_key_l,
        };
      } else {
        return { error: "Usuario o contraseña incorrectos" };
      }
    } else {
      return { error: "Usuario o contraseña incorrectos" };
    }
  } else {
    return { error: "Campos estan vacios" };
  }
}

export default function Login() {
  const [values, setValues] = useState(initialState);
  const [caja_n, setCajaN] = useState(0);
  const [modalCajas, setModalCajas] = useState(false);
  const [cajaData, setCajaData] = useState([]);
  const [todasCajas, setTodaCajas] = useState([]);
  const [error, setError] = useState(null);
  const { setToken, quitToken } = useContext(StoreContext);

  const history = useNavigate();
  const dataUrl = {
    1: "/user",
    2: "/user",
    3: "/user",
    4: "/user",
  };
  async function fetchCompania({ usr_key_login, compania }) {
    var response = await get_compania(usr_key_login, compania);
    return response;
  }
  async function get_setting() {
    var response = await get_cajas();
    var total_cajas = 0;
    
    response.map((data)=>{
      total_cajas= Number(total_cajas) +1; 
    })
   
    if(total_cajas===1){
      setCajaData(response[0]);
      setCajaN(response[0].caj_id);
    }
    else{
      setModalCajas(true);
      setTodaCajas(response);
    }
  }

  function onChange(event) {
    const { value, name } = event.target;

    setValues({
      ...values,
      [name]: value,
    });
    setError(null);
  }
  useEffect(() => {
    get_setting();
  }, []);

  async function onSubmit(event) {
    event.preventDefault();
    const {
      token,
      usr_perfil,
      usr_id,
      usr_nombre,
      usr_sucursal,
      usr_print,
      usr_company,
      com_suc_emisor,
      usr_ajustes,
      usr_factura,
      usr_inventario,
      usr_cotizacion,
      usr_articulo,
      usr_reporte,
      usr_a_costo,
      usr_apartado,
      usr_gastos,
      usr_clientes,
      error,
      usr_precio,
      usr_key_login,
    } = await login(values);
    if (token) {
      const response = await fetchCompania({ usr_key_login, compania: usr_sucursal });
      quitToken();
      setToken({
        token,
        dataCompania: response[0],
        compania: usr_sucursal,
        caja_n,
        usr_perfil,
        usr_id,
        usr_nombre,
        usr_sucursal,
        usr_print,
        com_suc_emisor,
        usr_company,
        usr_ajustes,
        usr_factura,
        usr_inventario,
        usr_cotizacion,
        usr_articulo,
        usr_reporte,
        usr_a_costo,
        usr_apartado,
        usr_gastos,
        cajaData,
        usr_clientes,
        usr_precio,
        usr_key_login,
      });
      if(cajaData.caj_id !== undefined){
        return usr_perfil === "3"
        ? history(dataUrl[usr_perfil] + "/factura")
        : history(dataUrl[usr_perfil] + "/home");
      }
     
    }
    setError(error);
    setValues(initialState);
  }

  return (
    <Container id="id-blogin" fluid>
      {modalCajas && (
        <ListaCajas
          dataCajas={todasCajas}
          isOpen={modalCajas}
          toggle={setModalCajas}
          setCajaData={setCajaData}
          setCajaN={setCajaN}
          />
      )}
      <Row>
        <Col xs={12} sm={12}>
          <Row className="mt-5">
            <Col xs={4}></Col>
            <Col xs={4} className="text-center">
              <img src={AVATAR} className="img-thumbnail img-w text-center" alt="..." />
            </Col>
            <Col xs={4}></Col>
          </Row>
          <Row className="mt-5">
            <Col xs={1} sm={4}></Col>
            <Col xs={10} sm={4}>
              <form onSubmit={onSubmit}>
                <MDBInput
                  className="mb-4"
                  type="text"
                  id="user"
                  label="Usuario"
                  name="usr_user"
                  onChange={onChange}
                  disabled={cajaData.caj_id !== undefined?false:true}
                  value={values.usr_user}
                />
                <MDBInput
                  className="mb-4"
                  type="password"
                  id="password"
                  label="Contraseña"
                  name="usr_pwd"
                  onChange={onChange}
                  disabled={cajaData.caj_id !== undefined?false:true}
                  value={values.usr_pwd}
                />
                {error && (
                  <div className="user-login__error font-weight-bold">
                    <Label className="text-danger font-weight-bold">{error}</Label>
                  </div>
                )}
                <MDBBtn type="submit" block disabled={cajaData.caj_id !== undefined?false:true}>
                  Iniciar sesión
                </MDBBtn>
              </form>
            </Col>
            <Col xs={1} sm={4}></Col>
            <Col sm={12} className="text-center mt-4">
              <Label>Desarrollado por www.mtechnologypanama.com</Label>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}
